var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 7h-2.5c-.827 0-1.5-.673-1.5-1.5V2H4v16h12V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 6v-.293l-3-3V5.5c0 .275.225.5.5.5H16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fill: "#605E5C",
    d: "M16.707 5L13 1.293A1 1 0 0012.293 1H4a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V5.707A1 1 0 0016.707 5zM16 5.707V6h-2.5a.501.501 0 01-.5-.5V2.707l3 3zM4 17.8V2.2c0-.11.09-.2.2-.2H12v3.5A1.5 1.5 0 0013.5 7H16v10.8a.2.2 0 01-.2.2H4.2a.2.2 0 01-.2-.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericfile);
export default __webpack_public_path__ + "static/media/genericfile.a5e1e077f08f75f9aa2cf0b6aef53dac.svg";
export { ForwardRef as ReactComponent };